module.exports = "https://web-assets.ifttt.com/packs/media/partners/documentation-884c44f0.svg";